import { Resource } from './resource';
import { Space, Sensor } from './api';

type SpaceResult = {
  resource_name: 'space';
  rank: number;
  result: {
    id: Space['external_id'];
    href_id: Space['external_id'];
    name: string;
    organization_name: string;
    organization_id: string;
  };
};

type SensorResult = {
  resource_name: 'unit';
  rank: number;
  result: {
    id: Sensor['serial_number'];
    href_id: string; // serial number
    name: string;
    organization_name: string;
    organization_id: string;
    doorway_name: string;
  };
};

export type SearchResult = SpaceResult | SensorResult;

export type GlobalSearchState = {
  searchText: string;
  results: Resource<Array<SearchResult>>;
  selectedIndex: number;
};

export enum GlobalSearchActionTypes {
  GLOBAL_SEARCH_SET_SEARCH_TEXT = 'GLOBAL_SEARCH_SET_SEARCH_TEXT',
  GLOBAL_SEARCH_CLEAR_SEARCH_TEXT = 'GLOBAL_SEARCH_CLEAR_SEARCH_TEXT',
  GLOBAL_SEARCH_SET_SELECTED_INDEX = 'GLOBAL_SEARCH_SET_SELECTED_INDEX',

  GLOBAL_SEARCH_RESOURCE_LOADING = 'GLOBAL_SEARCH_RESOURCE_LOADING',
  GLOBAL_SEARCH_RESOURCE_ERROR = 'GLOBAL_SEARCH_RESOURCE_ERROR',
  GLOBAL_SEARCH_RESOURCE_COMPLETE = 'GLOBAL_SEARCH_RESOURCE_COMPLETE',
}

export type GlobalSearchAction =
  | {
      type: GlobalSearchActionTypes.GLOBAL_SEARCH_SET_SEARCH_TEXT;
      text: string;
    }
  | { type: GlobalSearchActionTypes.GLOBAL_SEARCH_CLEAR_SEARCH_TEXT }
  | {
      type: GlobalSearchActionTypes.GLOBAL_SEARCH_SET_SELECTED_INDEX;
      index: number;
    }
  | { type: GlobalSearchActionTypes.GLOBAL_SEARCH_RESOURCE_LOADING }
  | { type: GlobalSearchActionTypes.GLOBAL_SEARCH_RESOURCE_ERROR; error: any }
  | {
      type: GlobalSearchActionTypes.GLOBAL_SEARCH_RESOURCE_COMPLETE;
      data: Array<SearchResult>;
    };
